import {ClickableContextMenuOption, ContextMenuDisplayGroup} from 'components/ContextMenu';
import addSamplesFromStructuredTable from 'notebook/sample-propagation/addSamplesFromStructuredTable';
import {AddToTableOptions} from 'notebook/sample-propagation/util/addSamplesToTable';
import isReadOnly from 'notebook/structured-tables/columns/isReadOnly';
import {ADD_FROM_STRUCTURED_TABLE_CONTEXT_MENU_OPTION_ID} from 'notebook/tables/core-ui/TableAxisCell';
import {Cell} from 'notebook/tables/TableConstants';
import {Note} from 'notebook/util/NoteUtilConstants';

import {
  StructuredTableColumn,
  UnknownStructuredTable,
  UnknownStructuredTableAdapter,
} from '../StructuredTableConstants';

export const ADD_FROM_STRUCTURED_TABLE_CONTEXT_MENU_OPTION_NAME = 'Add from structured table';

const TOOLTIP_DISABLED_SINGLE_INPUT = 'Cannot add to single input columns';
const TOOLTIP_DISABLED_ARCHIVED = 'Cannot add to archived columns';
const TOOLTIP_DISABLED_READ_ONLY = 'Cannot add to read-only columns';

/**
 * Define menu options for adding from Structured Table.
 *
 * These menu options will be part of each table column's context menu.
 *
 * This file is short for now but will be expanded upon in the future
 */

export default function getUnifiedAddSampleMenuOptions(
  destinationTable: UnknownStructuredTable,
  adapter: UnknownStructuredTableAdapter,
  tableIsLocked: boolean,
  note: Note | null,
  entryId: string,
  addSamples: (
    samplesByColumn: Array<{samples: Array<Cell>; columnIndex: number}>,
    options?: AddToTableOptions
  ) => void,
  destinationColumnIndex?: number
): Array<ClickableContextMenuOption> {
  const selectedColumn =
    destinationColumnIndex == null ? null : destinationTable.columns[destinationColumnIndex];
  const disabledTooltip = getDisabledTooltip({selectedColumn});
  return [
    {
      id: ADD_FROM_STRUCTURED_TABLE_CONTEXT_MENU_OPTION_ID,
      name: ADD_FROM_STRUCTURED_TABLE_CONTEXT_MENU_OPTION_NAME,
      displayGroup: ContextMenuDisplayGroup.MIDDLE,
      hide: tableIsLocked,
      click: () => {
        addSamplesFromStructuredTable({
          destinationTable,
          adapter,
          note,
          entryId,
          addSamples,
          destinationColumnIndex,
        });
      },
      disabled: Boolean(disabledTooltip),
      tooltip: disabledTooltip,
      dataTestAttrs: {component: 'ContextMenu', element: 'insertCustomColumn', key: 'strucTable'},
    },
  ];
}

function getDisabledTooltip({
  selectedColumn,
}: {
  selectedColumn: StructuredTableColumn | null;
}): string | undefined {
  if (selectedColumn == null) {
    return undefined;
  }
  if (isReadOnly(selectedColumn)) {
    return TOOLTIP_DISABLED_READ_ONLY;
  }
  if (selectedColumn.isArchived) {
    return TOOLTIP_DISABLED_ARCHIVED;
  }
  if (selectedColumn.isSingleInput) {
    return TOOLTIP_DISABLED_SINGLE_INPUT;
  }
  return undefined;
}
